<template>
  <div class="amministrazione">
    <Header></Header>

    <b-navbar
      toggleable="lg"
      style="background-color: #198754; border-radius: 4px; padding: 0"
    >
      <b-navbar-brand href="#" style="padding: 0">
        <b-button variant="success" @click="VaiA('/amministrazione')">
          <h3>{{ labels.amministrazione }}</h3>
        </b-button>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#">
            <b-button
              variant="success"
              @click="VaiA('/amministrazione/modificadatistruttura')"
              >{{ labels.modifica_dati_struttura }}</b-button
            >
          </b-nav-item>

          <b-nav-item href="#">
            <b-button
              variant="success"
              @click="VaiA('/amministrazione/gestioneutenti')"
              >{{ labels.gestione_utenti }}</b-button
            >
          </b-nav-item>

          <b-nav-item href="#">
            <b-button
              variant="success"
              @click="VaiA('/amministrazione/backoffice')"
              >{{ labels.backoffice }}</b-button
            >
          </b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item right>
            <b-button variant="success" @click="VaiA('/login')">{{
              labels.logout
            }}</b-button>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!--
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="warning"
      @dismiss-count-down="countDownChanged"
    >{{ labels.permessi_insufficienti }}</b-alert>
    -->

    <div class="router-view">
      <router-view />
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
//import Alert from "@/components/Alert";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import store from "@/store/index";
import router from "@/router/index";

export default {
  name: "Amministrazione",
  components: {
    Header,
    Footer,
    //Alert
  },

  data() {
    return {
      labels: {},
      labels_errori: {},
      size: "sm",
    };
  },
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },

  methods: {
    VaiA(link) {
      try {
        let route = customFilter(this.$router.options.routes, link);

        let requiresAuth = false;
        let is_admin = false;
        let meta = route.meta;
        if (meta != undefined) {
          requiresAuth = meta.requiresAuth;
          is_admin = meta.is_admin;
        }

        let UtenteAutenticato = this.$store.state.UtenteAutenticato;
        let UtenteAmministratore = this.$store.state.UtenteAmministratore;

        if (
          (requiresAuth && !UtenteAutenticato) ||
          (is_admin && !UtenteAmministratore)
        ) {
          this.$root.$children[0].$refs.ApplicationAlert.show(
            this.labels.permessi_insufficienti
          );
        } else {
          this.$router.push(link, null, function () {});
        }
      } catch (error) {
        this.registraErrore(error, "Amministrazione-VaiA");
      }
    },
    logout() {
      try {
        this.$router.push("/login");
      } catch (error) {
        this.registraErrore(error, "Amministrazione-logout");
      }
    },
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
    } catch (error) {
      this.registraErrore(error, "Amministrazione-created");
    }
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtenteAmministratore = store.state.UtenteAmministratore;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_admin && !UtenteAmministratore)
      ) {
        router.push("/login");
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      amministrazione: "Amministrazione",
      modifica_dati_struttura: "Modifica dati struttura",
      gestione_utenti: "Gestione utenti",
      backoffice: "BackOffice",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };
    let labels_inglese = {
      amministrazione: "Amministrazione",
      modifica_dati_struttura: "Modifica dati struttura",
      gestione_utenti: "Gestione utenti",
      backoffice: "BackOffice",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };
    let labels_tedesco = {
      amministrazione: "Amministrazione",
      modifica_dati_struttura: "Modifica dati struttura",
      gestione_utenti: "Gestione utenti",
      backoffice: "BackOffice",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };
    let labels_francese = {
      modifica_dati_struttura: "Modifica dati struttura",
      gestione_utenti: "Gestione utenti",
      backoffice: "BackOffice",
      logout: "Logout",
      permessi_insufficienti:
        "Permessi insufficienti per l'operazione richiesta",
    };

    let labels_errori_italiano = {};
    let labels_errori_inglese = {};
    let labels_errori_tedesco = {};
    let labels_errori_francese = {};

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "Amministrazione-fn_CambiaLingua");
  }
}

function customFilter(object, key) {
  try {
    for (let i = 0; i < object.length; i++) {
      if ("path" in object[i]) {
        if (object[i].path == key) {
          return object[i];
        }
      }

      if ("children" in object[i]) {
        let o = customFilter(object[i].children, key);
        if (o != null) {
          return o;
        }
      }
    }
  } catch (errore) {
    console.log(errore);
  }
}
</script>

<style scoped>
.amministrazione {
  min-height: auto;
  margin-top: 15px;
  margin-bottom: 15px;
}

.router-view {
  min-height: 300px;
}
</style>
